import { isFunction } from 'lodash-es'
import { useEffect, useRef, useState } from 'react'

const useGeolocation = (options) => {
  const [state, setState] = useState({
    loading: true,
    accuracy: null,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    latitude: null,
    longitude: null,
    speed: null,
    timestamp: Date.now(),
  })

  const mounted = useRef(true)

  const onEvent = (event) => {
    if (mounted) {
      setState({
        loading: false,
        accuracy: event.coords.accuracy,
        altitude: event.coords.altitude,
        altitudeAccuracy: event.coords.altitudeAccuracy,
        heading: event.coords.heading,
        latitude: event.coords.latitude,
        longitude: event.coords.longitude,
        speed: event.coords.speed,
        timestamp: event.timestamp,
      })
    }
  }

  const onEventError = (error) => {
    if (mounted.current) {
      setState((oldState) => ({ ...oldState, loading: false, error }))
    }
  }

  useEffect(() => {
    if (
      !isFunction(navigator?.geolocation?.getCurrentPosition)
      || !isFunction(navigator?.geolocation?.watchPosition)
      || !isFunction(navigator?.geolocation?.clearWatch)
    ) {
      setState((oldState) => ({ ...oldState, loading: false, error: new Error('Geolocation not supported') }))
      return () => { }
    }

    navigator.geolocation.getCurrentPosition(onEvent, onEventError, options)
    let watchId = navigator.geolocation.watchPosition(onEvent, onEventError, options)
    mounted.current = true

    return () => {
      mounted.current = false
      try {
        navigator.geolocation.clearWatch(watchId)
      } catch (error) { }
    }
  }, [options])

  return state
}

export default useGeolocation